import React from 'react';
import { observer } from 'mobx-react';
import { routerStore } from 'core/routing';

import { frameStore } from 'apps/components/Frame/appManager';
import { useChatControl } from 'libs/rendering/hooks';

import { ChatButtonStyled } from './headerFileFeatures.styled';

const noChatButtonsRoutes = ['make-part.file'];

const DiscussButton = observer(() => {
  const { file, contextManager } = frameStore;
  const chatControl = useChatControl();

  if (!file) return null;
  if (noChatButtonsRoutes.includes(routerStore.route.name)) return null;

  const isActive = chatControl.chatVisible;

  const handleClick = () => {
    const newParams = Object.assign({}, routerStore.route.params);
    if (newParams.panel === 'discuss') delete newParams.panel;
    else newParams.panel = 'discuss';
    routerStore.navigate(routerStore.route.name, newParams, { replace: true });
  };

  let unreadMessages = 0;
  if (contextManager) unreadMessages = contextManager.unreadCount;
  if (chatControl.chatVisible) unreadMessages = 0;

  return (
    <ChatButtonStyled
      icon='chat_multiple'
      iconPosition='right'
      data-test-id='discuss-button'
      text='Discuss'
      onClick={() => {
        handleClick();
      }}
      appearance='plain'
      removeBold
      active={isActive}
      badgeValue={unreadMessages}
    />
  );
});

export default DiscussButton;
